module.exports = __webpack_public_path__ + "img/logo.75074c34.svg";